<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 Delete “{{ segment.title }}” segment
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider
    v-card-text.pa-6
      .text-lg.font-medium.neutral700--text.mb-4  Are you sure you want to delete this segment?
      .text-md.neutral700--text This segment will be removed immediately. You can’t undo this action.
      .text-md.neutral700--text {{ $t('click_confirm_to_proceed') }}
    v-divider

    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.primary400--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md(@click="deleteSegment" :loading="isLoading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'segment'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteSegment () {
      this.isLoading = true
      this.$axios.delete(`/connect/${this.company.slug}/groups/${this.segment.id}`)
        .then(() => {
          this.showMessage(['success', 'Segment deleted successfully'])
          this.$emit('deleted')
          this.showDialog = false
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>